
import { all, takeLatest } from "redux-saga/effects";

/*  ACTIONS  */
import { startup, doLogin, doLogout } from "../actions/Session";
import {
    updateClient, addDocument,
    deleteDocument, refreshData
} from "../actions/Firebase";
import { getDocumentInfo, updateStation } from "../actions/Stations"
import { getLoadInfo } from "../actions/Loads"
import { updateSession } from "../actions/Session"

/* SAGAS */
import {
    initialize as StationsInit,
    getDocumentInfo as getDocumentInfoSagas,
    updateStation as updateStationSagas
} from "./Stations";
import {
    initialize as LoadsInit,
    getLoadInfo as getLoadInfoSagas,
} from "./Loads";
// eslint-disable-next-line
import { initialize as UsersInit } from "./Users";
import { initialize as TokensInit } from "./Tokens";
import {
    initialize as FirebaseInit,
    addDocument as createDocumentSagas,
    deleteDocument as deleteDocumentSagas
} from "./Firebase";
import {
    login, logout
} from "./Session";

export default function* root(firebaseApp) {
    yield all([
        takeLatest(startup, FirebaseInit, { firebaseApp }),
        takeLatest(updateClient, StationsInit),
        takeLatest(updateSession, LoadsInit),
        takeLatest(updateClient, UsersInit, {firebaseApp}),
        takeLatest(updateClient, TokensInit),
        takeLatest(refreshData, StationsInit),
        takeLatest(refreshData, LoadsInit),
        takeLatest(refreshData, TokensInit),
        takeLatest(addDocument, createDocumentSagas),
        takeLatest(getDocumentInfo, getDocumentInfoSagas),
        takeLatest(getLoadInfo, getLoadInfoSagas),
        takeLatest(deleteDocument, deleteDocumentSagas),
        takeLatest(doLogin, login, { firebaseApp }),
        takeLatest(doLogout, logout, { firebaseApp }),
        takeLatest(updateStation, updateStationSagas)
    ])
}